var map = {
	"./cover-gospooky.jpg": "aeba",
	"./cover-keytouch.jpg": "e8f5",
	"./cover-kinder.jpg": "fb95",
	"./cover-kurator.jpg": "c40b",
	"./cover-machine-learning.jpg": "837e",
	"./cover-manpower.jpg": "edb2",
	"./cover-moby-instant.jpg": "ac0f",
	"./cover-more.jpg": "a8d1",
	"./cover-remix.jpg": "3ad5",
	"./cover-speaky.jpg": "0f1a",
	"./cover-time.jpg": "3dc0",
	"./cover-tnw.jpg": "0094",
	"./cover-uu.jpg": "2c26",
	"./cover-woonwaard.jpg": "67ff",
	"./cover-wwdc.jpg": "4821",
	"./cover-yab.jpg": "2d7e",
	"./favicon.png": "99dd",
	"./iphone.png": "c4cb",
	"./phone-screen-erik-2.jpg": "6e84",
	"./phone-screen-erik-3.jpg": "6e90",
	"./phone-screen-erik.jpg": "69e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";